import "../chunk-PKUHTIDK.js";
import { linkClick } from "./index";
const api = ["linkClick"];
const renderless = (props, { inject }, { refs, router, emit }) => {
  const breadcrumbEmitter = inject("breadcrumbEmitter");
  const breadcrumb = inject("breadcrumb");
  const constants = breadcrumb._constants;
  const api2 = {
    linkClick: linkClick({ props, refs, router, emit, breadcrumbEmitter, constants })
  };
  return api2;
};
export {
  api,
  renderless
};
